import { useAtomValue } from 'jotai'
import { FC, useMemo } from 'react'
import { PropertyRecordsDetailsTaxes } from 'src/components/insights/property-records/details/taxes'
import { UnavailableCardContent } from 'src/components/insights/unavailable-card-content'
import { sortTaxes } from 'src/utils/property-records'
import { parcelPropertyRecords } from 'src/v2/state/owner-reveal/parcel-property-records'

export const ParcelPropertyTaxesContent: FC = () => {
  const data = useAtomValue(parcelPropertyRecords)

  const sortedData = useMemo(() => {
    if (!data) {
      return []
    }

    return sortTaxes(data.taxes)
  }, [data])

  if (!sortedData.length) {
    return <UnavailableCardContent message="Sorry, but we couldn't find the information requested for this parcel." />
  }

  return <PropertyRecordsDetailsTaxes taxes={sortedData} />
}
